import React from 'react'
import { Button } from '@duik/it'
import styled from '@emotion/styled'

type StyledButtonProps = {
  type: string
  success: boolean
  buttonStyle: 'primary' | 'secondary' | 'tertiary'
}

type Props = {
  success?: boolean
  type?: string
  disabled?: boolean
  name: string
  onClick?: () => void
  buttonStyle?: 'primary' | 'secondary' | 'tertiary'
}

const StyledButton = styled(Button)<StyledButtonProps>(({ buttonstyle }) => ({
  width: '100%',
  background:
    buttonstyle === 'tertiary'
      ? 'var(--bg-main)'
      : buttonstyle === 'secondary'
      ? 'linear-gradient(0deg, #289c91 0%, #31ada2 100%)'
      : 'linear-gradient(0deg, #34AA44 0%, #38B249 100%)',
  color: buttonstyle === 'tertiary' ? 'var(--text-main)' : '#FFFFFF',
  textAlign: 'center',
  fontSize: '16px'
}))

export const ModalButton: React.FC<Props> = ({
  buttonStyle,
  onClick,
  disabled,
  name,
  type,
  success
}) => {
  return (
    <StyledButton
      buttonstyle={buttonStyle}
      success={success}
      type={type === 'submit' ? 'submit' : 'button'}
      onClick={onClick}
      disabled={disabled}
    >
      {name}
    </StyledButton>
  )
}
